<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Registro de Acuerdos</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row new-row">
              <div class="col-4">
                <h2>Acuerdos del día</h2>
              </div>
            </div>
            <hr />
            <div>
              <Acuerdos
                :key="acuerdosKey"
                :prop_acuerdos="listaDeAcuerdos"
              ></Acuerdos>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import DatosGenerales from "@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosGenerales.vue";
import DatosFinales from "@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosFinales.vue";
import Acuerdos from "@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/Acuerdos.vue";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
export default {
  data() {
    return {
      listaDeAcuerdos: [],
      acuerdosKey: 0,
      fechaDeDictado: "2021-11-10",
    };
  },
  props: {},
  components: {
    Acuerdos,
  },
  methods: {
    
    obtenerFechaAyer() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      this.fechaDeDictado = yesterday.toISOString().split("T")[0];
    },
  },
  mounted: function mounted() {
    this.obtenerFechaAyer();
  },
  computed: {},
};
</script>

<style scoped>
span {
  font-weight: bold;
}
b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.fas {
  cursor: pointer;
}
.tab {
  overflow: hidden;
  padding-left: 15px;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: #45454c;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
  color: whitesmoke;
  border-right: 1px solid #ccc;
  width: 20vw;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
  color: #000;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: #ccc;
  color: #000;
  font-weight: bolder;
}
.bigtextarea {
  height: 100px;
}
</style>





// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/RegistroDeAcuerdos/RegistroDeAcuerdos.vue